import React from "react"

const Page6Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div className='mt-2 font-family-acumin font-18 line-height-24'>2 / 4</div>
        <div className='mt-2 font-16 line-height-20 font-uppercase'>Le flotte aziendali</div>
        <div className='mt-2 font-44 line-height-58 font-family-acumin font-weight-900'>
          Se al business piace il green
        </div>
        <div className='mt-4 mb-5 font-20 line-height-26'>
          Anche i veicoli aziendali si stanno
          spostando verso l’elettrico: ecco perché
          supportare questa (bella) transizione.
        </div>
      </div>
    </div>
  )
}

export default Page6Mobile
